var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{ref:"chart",attrs:{"type":_vm.data.type || 'line',"height":_vm.data.height ? _vm.data.height : '300',"options":_vm.config,"series":_vm.data.series}})}
var staticRenderFns = []

export { render, staticRenderFns }